export const removeStringFromWord = (word, stringToRemove) => {
  // if word is not a string, return empty string
  if (typeof word !== 'string') return ''

  // if stringToRemove is not a string, return given word
  if (typeof stringToRemove !== 'string') return word

  const regex = new RegExp(stringToRemove, 'g')
  return word.replace(regex, '')
}
